export class ParentGuardianDetails {
    
    SchoolProgramType: string;
    ParentGuardianId: number;

    RelationshipCode: string;
    OtherRelationship: string;
    GivenName: string;
    FamilyName: string;
    OnlyHasOneName: boolean;
    PreferredName: string;
    Gender: string;
    IsRefusedAusVisaBefore: boolean;
    VisaRefusalDetails: string;
    DateOfBirth: string;
    CountryOfBirthId: string;
    CountryOfNationalityId: string;
    HasPassport: boolean;
    PassportNumber: string;
    PassportExpiryDate: string;
    EmailAddress: string;

    MobileCountryCode: string;
    MobilePhoneNumber: string;
    HomeCountryCode: string;
    HomePhoneNumber: string;

    IsAustralianAddressCurrentAddress: boolean;
    AustralianAddressLine1: string;
    AustralianAddressLine2: string;
    AustralianSuburb: string;
    AustralianState: string;
  AustralianPostcode: string;
  //no AustraliaCountryId in database

    IsOverseasAddressCurrentAddress: boolean;
    OverseasAddressLine1: string;
    OverseasAddressLine2: string;
    OverseasSuburbTown: string;
    OverseasStateProvinceRegion: string;
    OverseasPostcode: string;
    OverseasCountryId: string;
    OverseasCountryName: string;

    IsDateOfBirthStatusChanged: boolean;
    IsDefaultCorrespondent: boolean;
    IsCorrespondentSelectionDisabled: boolean
    AgentNote: string;

    IsValid: boolean;
    HasLegalCustody: boolean;
    IsParent: boolean;
    IsDeceased: boolean;
    
}

export interface ParentErrors {
    IsParentTheCarer?: string;
}

export interface ParentInfo {
    Relationship: string;
    OtherRelationship: string;
    IsDeceased: boolean;
    GivenName: string;
    FamilyName: string;
    OnlyHasOneName: boolean;
    HasLegalCustody?: boolean;
}
export interface ParentInfoErrors {
    Relationship?: string;
    OtherRelationship?: string;
    IsDeceased?: string;
    GivenName?: string;
    FamilyName?: string;
    HasLegalCustody?: string;
}

export interface ParentInfoConfig {
    isSubmittedApplication?: boolean;
    isParentTheCarer?: boolean;
    isParent: boolean;
    ParentId?: number;
}

export interface ParentDetails {
SchoolProgramType: string;
DateOfBirth: string;
Gender: string;
CountryOfBirthId: string;
CountryOfNationalityId: string;
PassportNumber: string;
EmailAddress: string;
Note: string;
IsRefusedAusVisaBefore: boolean;
VisaRefusalDetails: string;
MobileCountryCode: string;
MobilePhoneNumber: string;
HomeCountryCode: string;
HomePhoneNumber: string;
IsAustralianAddress: boolean;
AddressLine1: string;
AddressLine2: string;
SuburbTownCity: string;
StateProvinceRegion: string;
Postcode: string;
CountryId: string;
IsSameAddress: boolean;
}

export interface ParentDetailsErrors {
    DateOfBirth?: string;
    Gender?: string;
    CountryOfBirthId?: string;
    CountryOfNationalityId?: string;
    PassportNumber?: string;
    EmailAddress?: string;
    Note?: string;
    IsRefusedAusVisaBefore?: string; 
    VisaRefusalDetails?: string;
    MobileCountryCode?: string;
    MobilePhoneNumber?: string;
    HomeCountryCode?: string;
    HomePhoneNumber?: string;
    IsAustralianAddress?: string;
    CountryId?: string;
    AddressLine1?: string;
    AddressLine2?: string;
    SuburbTownCity?: string;
    StateProvinceRegion?: string;
    Postcode?: string;
}
export interface ParentDetailsConfig {
    isSubmittedApplication?: boolean;
    isParentTheCarer: boolean;
    isParent: boolean;
    isSecondParent: boolean;
    isSameAddress: boolean;
    isP1ParentDeceased: boolean;
}
export interface ParentAddressConfig {
    isSubmittedApplication?: boolean;
    isParent: boolean;
    title: string;
    titleAdditionalInfo: string;
}
export interface ParentAddress {
    IsAustralianAddress?: boolean;
    AddressLine1?: string;
    AddressLine2?: string;
    SuburbTownCity?: string;
    StateProvinceRegion?: string;
    Postcode?: string;
    CountryId?: string;
}
export interface ParentAddressErrors {
    AddressLine1?: string;
    AddressLine2?: string;
    SuburbTownCity?: string;
    StateProvinceRegion?: string;
    Postcode?: string;
    CountryId?: string;
}
export class ParentLegalcustodianDetails {
SchoolProgramType: string;
IsParentTheCarer: boolean;
IsSingleParent: boolean;    
//Parent 1
P1ParentId : number;
P1RelationshipCode: string;
P1GivenName: string;
P1FamilyName: string;
P1OnlyHasOneName: boolean;
P1IsDeceased: boolean;
P1HasLegalCustody?: boolean;

P1DateOfBirth: string;
P1Gender: string;
P1CountryOfBirthId: string;
P1CountryOfNationalityId: string;
P1PassportNumber: string;
P1EmailAddress: string;
P1Note: string;
P1IsRefusedAusVisaBefore: boolean;
P1VisaRefusalDetails: string;

P1MobileCountryCode: string;
P1MobilePhoneNumber: string;
P1HomeCountryCode: string;
P1HomePhoneNumber: string;

P1IsAustralianAddress: boolean;
P1AddressLine1: string;
P1AddressLine2: string;
P1SuburbTownCity: string;
P1StateProvinceRegion: string;
P1Postcode: string;
P1CountryId: string;

//Parent 2
P2ParentId : number;
P2RelationshipCode: string;
P2GivenName: string;
P2FamilyName: string;
P2OnlyHasOneName: boolean;
P2IsDeceased: boolean;
P2HasLegalCustody?: boolean;

P2DateOfBirth: string;
P2Gender: string;
P2CountryOfBirthId: string;
P2CountryOfNationalityId: string;
P2PassportNumber: string;
P2EmailAddress: string;
P2Note: string;
P2IsRefusedAusVisaBefore: boolean;
P2VisaRefusalDetails: string;

P2MobileCountryCode: string;
P2MobilePhoneNumber: string;
P2HomeCountryCode: string;
P2HomePhoneNumber: string;

P2IsAustralianAddress: boolean;
P2AddressLine1: string;
P2AddressLine2: string;
P2SuburbTownCity: string;
P2StateProvinceRegion: string;
P2Postcode: string;
P2CountryId: string;


//Legal Custodian
LCParentId : number;
LCRelationshipCode: string;
LCOtherRelationship: string;
LCGivenName: string;
LCFamilyName: string;
LCOnlyHasOneName: boolean;

LCDateOfBirth: string;
LCGender: string;
LCCountryOfBirthId: string;
LCCountryOfNationalityId: string;
LCPassportNumber: string;
LCEmailAddress: string;
LCNote: string;
LCIsRefusedAusVisaBefore: boolean;
LCVisaRefusalDetails: string;

LCMobileCountryCode: string;
LCMobilePhoneNumber: string;
LCHomeCountryCode: string;
LCHomePhoneNumber: string;

LCIsAustralianAddress: boolean;
LCAddressLine1: string;
LCAddressLine2: string;
LCSuburbTownCity: string;
LCStateProvinceRegion: string;
LCPostcode: string;
LCCountryId: string;
}
